import { render } from "./StepTerms.vue?vue&type=template&id=11b861b0&scoped=true"
import script from "./StepTerms.vue?vue&type=script&lang=js"
export * from "./StepTerms.vue?vue&type=script&lang=js"

import "./StepTerms.vue?vue&type=style&index=0&id=11b861b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b861b0"]])

export default __exports__